import { Component } from '@angular/core';

@Component({
  selector: 'lib-copy',
  imports: [],
  templateUrl: './copy.html',
})
export class CopyIon {}
